module.exports = __webpack_public_path__ + "img/noprojectinfo.e96dc5da.jpg";